"use client";

import React from 'react';
import Image from 'next/image';

const BrandsSection = () => {
  // Updated to use correct image names from the directory
  const brands = [
    { name: 'Addlon', src: '/images/brands/addlon.png', width: 100, height: 29 },
    { name: 'Aetna', src: '/images/brands/aetna.png', width: 100, height: 29 },
    { name: 'AG4Good', src: '/images/brands/ag4good.png', width: 100, height: 29 },
    { name: 'Aramco', src: '/images/brands/aramco.png', width: 100, height: 29 },
    { name: 'ARM Holdings', src: '/images/brands/arm_holdings.png', width: 100, height: 29 },
    { name: 'Celeris', src: '/images/brands/celeris.png', width: 100, height: 29 },
    { name: 'Conta Azul', src: '/images/brands/conta_azul.png', width: 100, height: 29 },
    { name: 'Hirebridge', src: '/images/brands/hirebridge.png', width: 100, height: 29 },
    { name: 'HTGR', src: '/images/brands/htgr.png', width: 100, height: 29 },
    { name: 'JGS Group', src: '/images/brands/jgs_group.png', width: 100, height: 29 },
    { name: 'Minnesota State', src: '/images/brands/minnesota_state.png', width: 100, height: 29 },
    { name: 'Monash Health', src: '/images/brands/monash_health.png', width: 100, height: 29 },
    { name: 'Neurosensum', src: '/images/brands/neurosensum.png', width: 100, height: 29 },
    { name: 'BLS Polymers', src: '/images/brands/bls_polymers.png', width: 100, height: 29 },
    { name: 'Perceptiom', src: '/images/brands/perceptiom1.png', width: 100, height: 29 },
    { name: 'Perceptiom', src: '/images/brands/perceptiom2.png', width: 100, height: 29 },
    { name: 'Phanon.io', src: '/images/brands/phanon_io.png', width: 100, height: 29 },
    { name: 'Pixel', src: '/images/brands/pixel.png', width: 100, height: 29 },
    { name: 'Platform Commons', src: '/images/brands/platform_commons.png', width: 100, height: 29 },
    { name: 'Raheja Infra', src: '/images/brands/raheja_infra.png', width: 100, height: 29 },
    { name: 'Rallis India', src: '/images/brands/rallis_india.png', width: 100, height: 29 },
    { name: 'Segula', src: '/images/brands/segula.png', width: 100, height: 29 },
    { name: '1SEO', src: '/images/brands/1seo.png', width: 100, height: 29 },
    { name: 'Signium', src: '/images/brands/signium.png', width: 100, height: 29 },
    { name: 'Strategic Analysis', src: '/images/brands/strategic_analysis.png', width: 100, height: 29 },
    { name: 'Survey Sensum', src: '/images/brands/survey_sensum.png', width: 100, height: 29 },
    { name: 'SyncEzy', src: '/images/brands/syncezy.png', width: 100, height: 29 },
    { name: 'TCA', src: '/images/brands/tca.png', width: 100, height: 29 },
    { name: 'Tech Mahindra', src: '/images/brands/tech_mahindra.png', width: 100, height: 29 },
    { name: 'The Desk', src: '/images/brands/the_desk.png', width: 100, height: 29 },
    { name: 'Toop+Toop', src: '/images/brands/toop_toop.png', width: 100, height: 29 },
    { name: 'Vinsys', src: '/images/brands/vinsys.png', width: 100, height: 29 },
    { name: 'Vocal Labs', src: '/images/brands/vocal_labs.png', width: 100, height: 29 },
    { name: 'WNS', src: '/images/brands/wns.png', width: 100, height: 29 },
    { name: 'Capgemini', src: '/images/brands/capgemini.png', width: 100, height: 29 },
    { name: 'CBEC', src: '/images/brands/cbec.png', width: 100, height: 29 },
    { name: 'CRM Excellence', src: '/images/brands/crm_excellence.png', width: 100, height: 29 },
    { name: 'Dubai Real Estate', src: '/images/brands/dubai_real_estate.png', width: 100, height: 29 },
    { name: 'G-Square', src: '/images/brands/g-square.png', width: 100, height: 29 },
  ];

  return (
    <section className="pt-12 pb-0 bg-[#121212] text-white overflow-hidden">
      <div className="w-full md:w-[80%] mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-[1.375rem] md:text-[1.75rem] text-gray-100 mb-4">
            Trusted by 100+ top brands across the globe
          </h2>
        </div>

        {/* Continuous scrolling brands (marquee effect) */}
        <div className="relative w-full mx-auto">
          <div className="overflow-hidden relative">
            <div className="flex animate-infinite-scroll-mobile">
              {brands.map((brand, index) => (
                <div
                  key={`${brand.name}-${index}`}
                  className="flex-shrink-0 w-[180px] mx-4"
                >
                  <div className="flex items-center justify-center h-20 grayscale opacity-60 hover:opacity-100 transition-opacity">
                    <Image
                      src={brand.src}
                      alt={brand.name}
                      width={brand.width}
                      height={brand.height}
                      className="object-contain"
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="absolute top-0 left-0 w-8 h-full bg-gradient-to-r from-[#121212] to-transparent pointer-events-none"></div>
            <div className="absolute top-0 right-0 w-8 h-full bg-gradient-to-l from-[#121212] to-transparent pointer-events-none"></div>
          </div>
        </div>
      </div>

      <style jsx global>{`
        @keyframes infinite-scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-100%);
          }
        }
        .animate-infinite-scroll {
          animation: infinite-scroll 25s linear infinite;
        }
        .animate-infinite-scroll-mobile {
          animation: infinite-scroll 12.5s linear infinite;
        }
        
        @media (min-width: 768px) {
          .animate-infinite-scroll-mobile {
            animation: infinite-scroll 25s linear infinite;
          }
        }
        
        .animate-infinite-scroll:hover,
        .animate-infinite-scroll-mobile:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default BrandsSection; 